import React, { createContext, ReactNode, useContext, useEffect, useState } from 'react';
import { Art } from '../types';

export const ArtListContext = createContext<{ artList: Art[], loading: boolean } | undefined>(undefined);

export const useArtList = () => {
    const context = useContext(ArtListContext);
    if (context === undefined) {
        throw new Error('useArtList must be used within an ArtListProvider');
    }
    return context;
};

interface ArtListProviderProps {
    children: ReactNode;
}

const ArtListProvider: React.FC<ArtListProviderProps> = ({ children }) => {
    const [artList, setArtList] = useState<Art[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const controller = new AbortController();
        fetch('/artworks.json', { signal: controller.signal })
            .then((res) => res.json())
            .then((data: Art[]) => { setArtList(data); setLoading(false); })
            .catch((err) => {
                if (err.name !== 'AbortError') {
                    console.error('Failed to load artworks:', err);
                    setLoading(false);
                }
            });
        return () => controller.abort();
    }, []);

    return (
        <ArtListContext.Provider value={{ artList, loading }}>
            {children}
        </ArtListContext.Provider>
    );
};

export default ArtListProvider;
